import ParametersPool from "./ParametersPool"
import IndicatorsPool from "./IndicatorsPool"
import Models from "./Models"


function getFormula(indId) {
  if(window.formulas[indId] !== undefined) {
    return window.formulas[indId].func
  } else {
    return window.MULT
  }
}

function getFactorsByIndicators(selectedActions, relations) {
  let allFactors = {}

  for(let i in selectedActions) {
    let actionId = selectedActions[i]
    let aepRelations = relations[actionId]
    if(aepRelations !== undefined) {
      for( var indId in aepRelations ) {
        if(allFactors[indId] === undefined) allFactors[indId] = {}
        let coef = aepRelations[indId]
        allFactors[indId][actionId] = coef
      }
    }
  }

  /*{
    indId : [factor1, factor2, factor3],
    indId2 : [factor4, factor5, factor6],
  }*/
  return allFactors
}

function processIndicator(indId, indicator, newValues, yearNumber, allFactors, selectedActionsIds, prevSelectedActionsIds) {
  const paramId = indicator.parameter_id
  const val = ParametersPool.getDef(paramId) // can be undefined
  const min = ParametersPool.getMin(paramId) // can be undefined
  const max = ParametersPool.getMax(paramId) // can be undefined

  let factors = allFactors[indId]

  // ici faire le calcul
  let formula = getFormula(indId)

  let newVal = formula(val, factors, ParametersPool, newValues, yearNumber, IndicatorsPool.values, selectedActionsIds, prevSelectedActionsIds, Models.all)

  // clamp entre min et max
  if(min !== null && newVal < min) newVal = min
  if(max !== null && newVal > max) newVal = max

  if(isNaN(newVal)) {
    console.warn("Error indicator", indId, "valeur undefined")
    newVal = undefined
  }

  return newVal

}

export function process(yearNumber, relations, selectedActions, prevSelectedActions) {
  let newValues = {}
  const indicators = IndicatorsPool.all

  indicators.sort((a, b) => {
    let levelA = IndicatorsPool.levels[a.id]
    let levelB = IndicatorsPool.levels[b.id]

    if(levelA < levelB) return -1
    if(levelA > levelB) return 1
    return 0
  })

  let allFactors = getFactorsByIndicators(selectedActions, relations)
  let selectedActionsIds = Object.values(selectedActions)
  let prevSelectedActionsIds = Object.values(prevSelectedActions)

  indicators.forEach(indicator => {
    const indId = indicator.id
    newValues[indId] = processIndicator(indId, indicator, newValues, yearNumber, allFactors, selectedActionsIds, prevSelectedActionsIds)
  })

  return newValues
}
